import React from 'react';
import './FilterStyles.css';

const EMPLOYMENT_TYPES = [
  'Full-Time',
  'Part-Time',
  'Self-Employed (with employees)',
  'Self-Employed (solo)',
  'Unemployed',
  'Student',
  'Retired',
  'Home Maker',
  'Long-Term Sick/Disabled',
  'Other'
];

const EmploymentFilter = ({ filter, onUpdate, onRemove }) => {
  const { employmentTypes = [] } = filter.values;

  const handleToggle = (employment) => {
    const newEmploymentTypes = employmentTypes.includes(employment)
      ? employmentTypes.filter(e => e !== employment)
      : [...employmentTypes, employment];

    onUpdate({
      ...filter,
      values: { ...filter.values, employmentTypes: newEmploymentTypes }
    });
  };

  return (
    <div className="filter-container">
      <div className="filter-header">
        <h3>Employment</h3>
        <button className="filter-remove-btn" onClick={onRemove}>×</button>
      </div>

      <div className="filter-section">
        {EMPLOYMENT_TYPES.map(employment => (
          <label key={employment} className="filter-checkbox">
            <input
              type="checkbox"
              checked={employmentTypes.includes(employment)}
              onChange={() => handleToggle(employment)}
            />
            <span>{employment}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default EmploymentFilter;
